import { Component, TemplateRef, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { combineLatest, from } from 'rxjs';
import { map } from 'rxjs/operators';

import { RootState } from '../../../root-store/root.state';
import { ImagingService } from '../../../services/imaging/imaging.service';
import { selectViewerConnected } from '../../../connectivity/connectivity.selectors';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'se-header-connectivity',
    templateUrl: './se-header-connectivity.component.html',
    styleUrls: ['./se-header-connectivity.component.scss'],
})
export class SeHeaderConnectivityComponent {
    @ViewChild('viewerInfoTemplate') viewerInfoTemplate: TemplateRef<unknown>;

    viewerState$ = combineLatest([
        this.store.pipe(select(selectViewerConnected)),
        from(this.imaging.getViewerType()),
    ]).pipe(
        map(([viewerOpen, viewerType]) => ({
            enabled: this.isVNextViewerEnabled(viewerType),
            icon: viewerOpen ? 'desktop_windows' : 'desktop_access_disabled',
            tooltip: this.getViewerStateTranslation(this.isVNextViewerEnabled(viewerType))
        })),
    );

    constructor(private imaging: ImagingService, private store: Store<RootState>,
        private translate: TranslateService) { }

    openViewer() {
        this.imaging.openViewer();
    }

    private isVNextViewerEnabled(viewerType: string) {
        return viewerType === 'EstensaReviewVNext' || viewerType === 'SeWebViewer';
    }

    getViewerStateTranslation(enabled: boolean) {
        return enabled ? this.translate.instant('ViewerConnected') : this.translate.instant('ViewerDisconnected');
    }
}
